import { buildMappedUrl, RootUrlMap } from '../RootRouter.url';

export const BuilderTemplateGalleryUrlMap = {
    index: buildMappedUrl(RootUrlMap.builderTemplateGallery, ''),
} as const;
